import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const linkIssueEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-link-issue-content-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
